import { Injectable } from '@angular/core';
import { AppSettingController } from '@commoncore/controller/AppSettingController';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  localStorageSvc: any;

  constructor(public globalService:GlobalService){
    this.localStorageSvc = globalService.getLocalStorageSvcRef();
  }

  async updateSettings(){
    let appSettingController = AppSettingController.getInstance(this.globalService);
    appSettingController.populateAPIEndpointsInEnv();
    // $("#jc-app-init-loader-cont").hide();
    return true;
  }

  async fetchSettings(){
    let appSettingController = AppSettingController.getInstance(this.globalService);
    let appSettingImpl = appSettingController.appSettingImplementation;
    appSettingController.populateAPIEndpointsInEnv();
    let dcGroupCode = this.localStorageSvc.getDCGroupCode(true);
    appSettingController.setAppSetting(dcGroupCode);
    appSettingImpl.callMandatoryAPIsOnPageLoad();
  }
}
